import PropTypes from 'prop-types';

import FeatureErrorBoundary from 'ui-component/FeatureErrorBoundary';

// Lỗi trong tính năng đăng ký lưu trú KHÔNG được phép làm trắng màn hình toàn app.
// Phần ruột nằm ở FeatureErrorBoundary — dùng chung với popup thông báo trang chủ.
const DangKyLuuTruErrorBoundary = ({ children }) => <FeatureErrorBoundary ten="đăng ký lưu trú">{children}</FeatureErrorBoundary>;

DangKyLuuTruErrorBoundary.propTypes = {
    children: PropTypes.node
};

export default DangKyLuuTruErrorBoundary;
